import React from "react";

import Image from "./Nyawira-work.jpg";
import "./Home.css";

  const toolList = {
    // A list of tools used and a list of examples
    "Front-End and CMS": {
      "id": 1,
      "tools": ["JavaScript", "HTML/DOM", "CSS", "React Js", "JQuery", "BootStrap", "Materialize CSS", "Material Design For Bootstrap", "Mockup Tools(Canva, Balsamiq, Figma etc.)", "Joomla", "WordPress(LearnDash, Elementor + other Plugins)"]
    },
    "Back-End" : {
      "id": 2,
      "tools" : ["JavaScript", "Python", "REST APIs"]
    },
    "Version Control" : {
      "id" : 3,
      "tools": ["Git", "Github", "Bitbucket"]
    },
    "Databases & ORMs" : {
      "id" : 4,
      "tools": ["PostgreSQL(sequelize)", "MongoDB(Mongoose)", "SQLAlchemy(sqlite3)"]
    },
    "Project Planning & Management (Agile Process)" : {
      "id" : 5,
      "tools" :["Jira", "Trello", "Slack", "Gitter", "Adium", "Pivotal Tracker", "Github Projects"]
    },
    "Testing and Quality Assurance" : {
      "id" : 6,
      "tools": ["Jest", "Enzyme", "Mocha", "Chai", "Jasmine", "Karma", "SuperTest"]
    },
    "Continuous Integration and Coverage" : {
      "id" : 7,
      "tools" : ["Travis CI", "Code Climate", "Circle CI", "HoundCI", "Coveralls", "Linters" ]
    },
    "Deployment" : {
      "id" : 8,
      "tools" : ["Heroku", "Bluehost", "CloudFlare", "Vercel", "Self-hosted"]
    },
    "Documentation tools & Experience" : {
      "id" : 9,
      "tools" : ["Apiary.io", "GitHub", "Process documentation", "Planning documentation", "Estimate documentation", "Standards documentation", "Metrics documentation", "Scheduling documentation", "Product documentation", "System documentation", "Requirements documentation", "Architecture and design documentation", "Technical documentation", "User documentation", "End-user documentation", "System administrator documentation"]
    }
  }

  const intro = (
    // Introduction snippet of who I am
    <div className="">
      <h2 className="mb-3">Hello and welcome to my page!</h2>
      <p>I am a full-stack Javascript and advancing Python developer based in Nairobi, Kenya. </p>
      <p>Currently, I am the <strong>Software Engineering and Technology Lead</strong> at The Mawazo Institute.</p>
      <p>I have strong knowledge in the following technologies:-</p>
    </div>
  );

  const myPic = (
    // Nyawira's picture
    <div className="mr-0">
      <figure id="Nyawira-1" className="figure mt-3 ml-3 my-auto mr-3">
        <img className="figure-img img-thumbnail img-responsive rounded" src={Image} alt="" />
        <figcaption className="figure-caption text-center font-italic">Nyawira Wanjiru in October 2018, dressed up as Harry Potter for Halloween. Nairobi, Kenya.</figcaption>
      </figure>
    </div>
  );

  const details = (
    // List all toolList items and their associated tool examples
    <div className="pb-lg-2">
      <div className="output">
        <small className="text-dark">*Click on a link below to view the associated tools</small>
        <br />
        <div id="accordion" className="output-text mt-1 pb-4">
        {/* map through the Keys in the toolList array to create dropdowns with Keys as List title */}
        {Object.keys(toolList).map((item, index) => (
          <div key={"item" + index} className="card p-0 m-0 item-card">
            <div className="card-header p-0 header-txt item-header">
              <h2 className="m-0"> 
              {/* eslint-disable-next-line */}
                <a role="button" href="#" className="btn btn-link btn-lg col-sm-12 text-left" data-toggle="collapse" data-target={"#collapse" + index} aria-expanded="true" aria-controls="collapseOne">
                  <u className="accordion-items">{item}</u>
                </a>
              </h2>
            </div>
            <li key={"collapse" + index} id={"collapse" + index} className="collapse" aria-labelledby={index} data-parent="#accordion">
              <div id={"toolList" + index} className="card-body row font-weight-normal pt-2 pb-1">
              {/* Access the tools array within each toolList item to create a list of each tool. Split items into two columns based on whether their index(i) is dvisible by 2 */}
              {toolList[item].tools. map((tool, i)=>{
                return (
                  <div key={i} className="col-md-6">
                   {i % 2 == 0 ? 
                    <ul>
                    <li id={"tool" + i} style={{whiteSpace: 'pre-line'}} >{tool}</li>
                  </ul> 
                  : 
                  <ul>
                    <li id={"tool" + i} style={{whiteSpace: 'pre-line'}} >{tool}</li>
                  </ul>
                   }
                  </div>
                  
                  )
                })}
              </div>
            </li>
          </div>
        ))}
        </div>
      </div>
    </div>
  );

  const Home = () => {
    // Stateless component that will we exported with all the relevant data to be rendered
    return (
      <div id="home-page" className="home-page mt-lg-5 mb-4 pb-lg-3 container">
        <div>
          {intro}
        </div>
        <div className="container mb-5">
          <div className="row float-top">
            <div className="col-lg-8 deets">{details}</div>
            <div className="col-lg-4 img">{myPic}</div>
            
          </div>
        </div>     
      </div>
    );
  }

export default Home;
